import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "@/v2/assets/utils";

export function DateFormatter({ value }: { value: string }) {
  return <>{dayjs(value).format(DATE_TIME_FORMAT)}</>;
}
